import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import {isUndefined} from "lodash-es";


export type ShareKind = 'android'|'facebook'|'twitter'| 'sms';
/**
 * Prośba o nawigację
 */
export class ShareRequest extends NfComponentGlobalMessage {
    declare public shareKind: 'android'|'facebook'|'twitter'| 'sms';

    /*
     *
     */
    public constructor(
        shareKind: ShareKind | MessageEvent<ShareRequest>,
        public shareTitle?:string,
        public shareDescription?:string,
        public sharedRoute?: string,
        public widget_id?: number,
    ) {
        super(NfMessageType.ShareRequest, !NfMessage.isMessageEvent(shareKind));
        if(NfMessage.isMessageEvent(shareKind)) {
            Object.assign(this, shareKind.data);
        } else {
            if(isUndefined(shareKind) || shareKind === null) {
                throw Error('shareKind jest wymagany');
            }
            this.shareKind = shareKind;
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.ShareRequest] = (event) => {
    return new ShareRequest(event);
}
